import React, { useState } from 'react'
import { useStyles } from './styles'
import { concatStyles } from 'src/utils'
import { Popup } from '../Popup'
import HelpIcon from '@material-ui/icons/Help'

interface CustomInputProps {
  label?: string
  error?: string
  className?: string
  placeholder?: string
  onPressEnter?: Function
  onChange?: Function
  onBlur?: Function
  onFocus?: Function
  register?: Function
  type?: string
  value?: string | number | any
  disabled?: boolean
  id?: string
  maxLength?: number
  max?: string
  min?: string
  oninput?: string
  style?: any
  onClick?: Function
  autoComplete?: any
  readOnly?: boolean
  helperText?: string | (() => React.ReactNode)
}

export const Input: React.FC<CustomInputProps> = ({
  label,
  error,
  className,
  onPressEnter,
  onChange,
  onBlur,
  onFocus,
  autoComplete,
  register,
  id,
  helperText,
  ...rest
}) => {
  const [helperTextOpen, setHelperTextOpen] = useState(false)
  const { customInputWrapper } = useStyles()
  const handlePress = ({ key }: React.KeyboardEvent) => {
    if (key === 'Enter' && onPressEnter) onPressEnter()
  }
  const handleChange = ({ currentTarget }: React.FormEvent<HTMLInputElement>) => {
    if (onChange) onChange(currentTarget.value)
  }
  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    if (onBlur) onBlur(event)
  }
  const handleFocus = (event: React.FocusEvent<HTMLInputElement>) => {
    if (onFocus) onFocus(event)
  }

  const inputOnlyNumber = (event: any) => {
    if (rest?.type === 'number') {
      if (event.key === '+' || event.key === '-') {
        event.preventDefault()
      }
    }
  }
  const handleHelperTextClose = () => {
    setHelperTextOpen(false)
  }

  const handleHelperTextOpen = () => {
    setHelperTextOpen(true)
  }
  return (
    <>
      <div className={concatStyles(customInputWrapper, className)}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <label htmlFor={id || ''} className='custom-input__label'>
            {label}
          </label>
          {helperText && (
            <span className='custom-input__helper-text' onClick={handleHelperTextOpen}>
              <HelpIcon className='custom-input__helper-text-icon' />
            </span>
          )}
        </div>
        <input
          id={id || ''}
          autoComplete={autoComplete}
          className={`custom-input__input ${error ? 'custom-input__input--error' : ''}`}
          {...(register && register())}
          {...rest}
          onKeyPress={handlePress}
          onChange={handleChange}
          onBlur={handleBlur}
          onFocus={handleFocus}
          onKeyDown={inputOnlyNumber}
        />
        {error && (
          <span style={{ top: helperText ? 80 : 66 }} className='custom-input__error'>
            {error}
          </span>
        )}
      </div>
      {helperText && helperTextOpen && (
        <Popup className='helper-text-popup' title='Ajuda' onClose={handleHelperTextClose}>
          {typeof helperText === 'function' ? helperText() : <p>{helperText}</p>}
        </Popup>
      )}
    </>
  )
}
